/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Type de chauffage du bien — libellés, sous-catégories et compatibilité avec la nature dans form-rules/property-form.json (champ heatings)
 */
export const propertyHeatingTypeCodeSchema = z.enum(["OIL", "GAS", "ELECTRIC", "WOOD", "CENTRAL", "SOLAR", "GEOTHERMAL", "HEAT_PUMP", "AIR_CONDITIONING", "AEROTHERMAL"]).describe("Type de chauffage du bien — libellés, sous-catégories et compatibilité avec la nature dans form-rules/property-form.json (champ heatings)")